import { Control, Controller, FieldValues, Path } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { ComponentProps } from "react";
import PasswordInput from "components/password-input";

export interface FormPasswordProps<T extends FieldValues> extends ComponentProps<typeof TextField> {
  control: Control<T, any>;
  name: Path<T>;
}

const FormPassword = <T extends FieldValues>({ name, control, helperText, ...inputProps }: FormPasswordProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...field }, fieldState: { error }, formState: { isSubmitted } }) => (
        <PasswordInput
          color="primary"
          helperText={isSubmitted && !!error ? error?.message : helperText}
          error={isSubmitted && !!error}
          value={value ?? ""}
          {...field}
          {...inputProps}
        />
      )}
    />
  );
};

export default FormPassword;
